import React, { Fragment, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AutoComplete, Span } from 'components/Ui';
import CaretDown from 'components/Ui/CustomIcons/CaretDown';
import { createStructuredSelector } from 'reselect';
import get from 'lodash/get';
import find from 'lodash/find';
import {
  selectServiceLocationIsFetching,
  selectSelectedServiceLocation,
} from 'containers/PrimoAccount/selectors';
import { loadServiceLocation } from 'containers/PrimoAccount/actions';
import { showDrawer as showDrawerAction } from 'containers/DrawerManager/actions';
import styles from './styles.scss';

const InvoicesAddressSelectDisplay = ({
  addresses,
  defaultValue,
  _id,
  name,
  isFetching,
  _showDrawer,
  isBilling,
  handleAddressChange,
  _selectedServiceLocation,
  ...props
}) => {
  const formatLabel = (address, asOption = false) => {
    const address1 = address && address.address1 ? address.address1 : null;
    if (typeof item === 'symbol') {
      return address;
    }
    if (address && props && address1) {
      const {
        address2,
        postalCode,
        stateOrProvinceCode,
        id: billingLocationId,
        city,
      } = address;

      const selected = billingLocationId === get(currentValue, 'value', null);
      return (
        <Fragment>
          <div className={styles.labelContainer}>
            <div className={styles.label}>
              <div>
                {<Span className={styles.location}>Location #</Span>}{' '}
                {`${billingLocationId}`}
              </div>
              <div
                className={styles.address}
              >{`${address1.toLowerCase()}, ${city.toLowerCase()}, ${stateOrProvinceCode} ${postalCode}`}</div>
              {asOption && address2 && <span>{`${address2}`}</span>}
            </div>
            {asOption && selected && <div className={styles.selected} />}
          </div>
        </Fragment>
      );
    }
    return address;
  };

  // TODO: Check with Rajesh about this, he had null for both
  const [currentValue, changeValue] = useState({
    value: '',
    label: '',
  });

  useEffect(() => {
    if (defaultValue) {
      changeValue({
        value: defaultValue.id,
        label: defaultValue,
      });
    }
  }, [defaultValue]);

  const handleChange = (selectedAddress) => {
    changeValue(selectedAddress);
    if (handleAddressChange) {
      const selected = find(
        addresses,
        (address) => address.id === selectedAddress.value,
      );
      handleAddressChange(selected);
    }
  };

  return (
    <Fragment>
      <AutoComplete
        darkDropdown
        icon={<CaretDown />}
        name={name}
        label={isBilling ? 'Billing address:' : 'Delivery address:'}
        formatLabel={formatLabel}
        options={addresses.map((address) => ({
          value: address.id,
          label: formatLabel(address, true),
        }))}
        value={currentValue}
        onChange={handleChange}
        isFetching={isFetching}
        isClearable={false}
        selectClassName={props.selectClassName}
        isSearchable={false}
      />
    </Fragment>
  );
};
InvoicesAddressSelectDisplay.propTypes = {
  addresses: PropTypes.array,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  isFetching: PropTypes.bool.isRequired,
  selectedServiceLocation: PropTypes.object,
  loadServiceLocation: PropTypes.func.isRequired,
  showDrawer: PropTypes.func.isRequired,
  selectClassName: PropTypes.string,
  isBilling: PropTypes.bool,
  handleAddressChange: PropTypes.func.isRequired,
  defaultValue: PropTypes.object,
};
InvoicesAddressSelectDisplay.defaultProps = {
  id: '',
  isBilling: false,
};
const mapStateToProps = createStructuredSelector({
  isFetching: selectServiceLocationIsFetching(),
  selectedServiceLocation: selectSelectedServiceLocation(),
});
const mapDispatchToProps = {
  loadServiceLocation,
  showDrawer: showDrawerAction,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InvoicesAddressSelectDisplay);
